import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PricingGroupService {
    constructor(private http: HttpClient) { }
    /*
    * Get pricing-group by id or key
    */
    getPricingGroup(value: string | number): Observable<object> {
        return this.http.get(`${environment.apiUrl}pricing-group/view/${value}`, {});
    }
    /*
    * Get all pricing-group 
    */
    getAll(filter?: any): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}pricing-group`, filter);
    }
    /*
    * Create pricing-group 
    */
    create(data: any): Observable<object> {
        return this.http.post(`${environment.apiUrl}pricing-group/create`, data);
    }
    /*
    * Update pricing-group 
    */
    update(data: any): Observable<object> {
        return this.http.put(`${environment.apiUrl}pricing-group/update/${data._id}`, data);
    }
    /*
    * Delete pricing-group 
    */
    delete(data: any): Observable<any> {
        return this.http.delete(`${environment.apiUrl}pricing-group/delete/${data._id}`);
    }

    /*
    * Delete delete pricing-group 
    */
    bulkDelete(ids: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}pricing-group/bulk-delete`, { ids });
    }

}
